import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20gaming%20battlefield%20with%20energy%20waves%20and%20light%20streaks%20in%20dark%20space%2C%20warm%20orange%20and%20amber%20gradients%2C%20futuristic%20gaming%20vibe%2C%20clean%20minimal%20background%2C%20no%20text%2C%20no%20logos%2C%20dark%20atmosphere%20with%20glowing%20particles&width=1920&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-transparent to-background-50/90"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100">
          准备好了吗？
          <br />
          <span className="text-primary-500">立即加入 galagame</span>
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
          加入 galagame 千万玩家社区，探索无限游戏世界，享受专属福利与实时竞技乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/"
            className="px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            免费注册
            <i className="ri-user-add-line ml-2"></i>
          </Link>
          <Link
            to="/category"
            className="px-8 py-3.5 text-sm font-semibold text-foreground-200 border border-background-300 hover:border-primary-500 hover:text-primary-500 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览游戏
            <i className="ri-gamepad-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}